import { GetAdvisorListRequest } from '@finance-lab/utils/types'
import ApiBase from './Api'

const ADVISOR_API_PATHS = {
    ADVISORS: '/advisors',
    ADVISOR_BY_ID: (advisorId: string) => `/advisors/${advisorId}`,
}

class AdvisorApi extends ApiBase {
    async findAll() {
        const response = await this._getRequest<GetAdvisorListRequest>(ADVISOR_API_PATHS.ADVISORS)

        return response
    }
}

export default AdvisorApi
